import { CARD_TYPES } from "../components/Card/constants";

export const POSITION_MAIN = "main";
export const POSITION_RIGHT = "right";
export const TYPE_LINEUP = "lineup";
export const TYPE_NEWSLETTER = "newsletterelement";
export const TYPE_CUSTOMHTML = "html";
export const TYPE_SPONSORED = "sponsoredwidget";
export const TYPE_ADELEMENT = "adelement";
export const TYPE_MYLOCAL = "mylocal";
export const TYPE_SHORTS = "shorts";
export const TYPE_MUSTWATCH = "mustwatch";
export const TYPE_CLIENTSIDE = "clientsidewebcomponent";
export const TYPE_CONTESTPROMO = "contestpromoelement";
export const TYPE_CTA = "ctawidget";
export const TYPE_RECOMMENDED_VIDEO = "recommendedvideo";
export const TYPE_MY_OLYMPICS = "myolympics";
export const TYPE_RADIOBAR = "radiobar";
export const TYPE_TRENDING = "trending";
export const TYPE_CONTENT_QUERY_WIDGET = "contentQueryWidget";
export const TYPE_MLDRIVEN_ITEMS = "mlDrivenItems";

export const PAGE_COMPONENT_UNIVERSAL_CLASS_NAME = "pageComponent";
export const TYPE_SCHEDULE = "schedule";

export const TYPE_BROADCAST_SCHEDULE = "broadcastschedule";
export const TYPE_CONTENT_PACKAGE = CARD_TYPES.TYPE_CONTENT_PACKAGE;
